import React from 'react';
import { TrainingGoalSection } from '@/components/training-goals/TrainingGoalSection';

interface MonthlyProgressSectionProps {
  showForPractitionerMode?: boolean;
}

const MonthlyProgressSection: React.FC<MonthlyProgressSectionProps> = ({ 
  showForPractitionerMode = true 
}) => {
  // Only show if we're in practitioner mode
  if (!showForPractitionerMode) {
    return null;
  }

  return (
    <section className="mb-8">
      <TrainingGoalSection />
    </section>
  );
};

export default MonthlyProgressSection;
